import axios from "axios";
import { IFranchiseEmployees } from "../../../modules/CarrierAgreementMgmt/Employees/Franchise/types";
import { toast } from "../../../components/toastNotification";
const api_base_url = process.env.REACT_APP_API_BASEURL;

//Get Franchise Employee
export const getFranchiseEmployees = async () => {
  try {
    const data = await axios.get<IFranchiseEmployees[]>(
      `${api_base_url}/FranchiseEmployee`
    );
    if (data.status === 200) {
      return data.data;
    } else {
      toast.fire(
        "Warning",
        "Cannot Retrieve Data, please check connection or contact your admin",
        "error"
      );
      return [];
    }
  } catch (error) {
    throw new Error("Server Error");
  }
};

//Insert New Franchise Employee
export const addFranchiseEmployee = async (newFranchiseEmp) => {
  return await axios.post(`${api_base_url}/FranchiseEmployee`, {
    ...newFranchiseEmp,
  });
};

// Get Franchise Employee By Id
export const getFranchiseEmpForEdit = async (id) => {
  return await axios
    .get(`${api_base_url}/FranchiseEmployee/ForEdit/${id}`)
    .then((res) => {
      return res.data;
    });
};

//Edit Franchise Employee
export const updateFranchiseEmployee = async (editFranchiseEmp) => {
  return await axios.put(`${api_base_url}/FranchiseEmployee`, editFranchiseEmp);
};

// Deactivate Franchise Employee
export const deactivateFranchiseEmpId = async (ids) => {
  return await axios.put(
    `${api_base_url}/FranchiseEmployee/FranchiseEmployeeToDeactivate`,
    ids
  );
};
